import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { withLatestFrom, switchMap, catchError, of, map } from "rxjs";
import { CatalogClient } from "src/api-service";
import { selectSelectedCompany } from "../../../user/user.selectors";
import { CatalogsActions } from "./catalogs.actions";
import { normalizeError } from "../../../app-store-error.types";

@Injectable()
export class CatalogsEffects {
    private readonly actions$ = inject(Actions);
    private readonly store = inject(Store);
    private readonly catalogClient = inject(CatalogClient);

    load$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CatalogsActions.load),
            withLatestFrom(this.store.select(selectSelectedCompany)),
            switchMap(([, selectedCompany]) => {
                const companyId = selectedCompany?.id;
                if (!companyId) {
                    return of(CatalogsActions.loadFailure({ error: { message: "No company selected" }, toastKey: "CATALOG_PREVIEW.TOAST.LOAD_LIST_ERROR" }));
                }
                return this.catalogClient.getAll(companyId).pipe(
                    map(catalogs => CatalogsActions.loadSuccess({ catalogs })),
                    catchError(error =>
                        of(CatalogsActions.loadFailure({ error: normalizeError(error), toastKey: "CATALOG_PREVIEW.TOAST.LOAD_LIST_ERROR" })),
                    ),
                );
            }),
        ),
    );
}
